import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .AddressProofModal {
    text-align: center;
    padding: 40px 30px 30px;
    max-width: 500px;
  }

  .ReactModal__inner h2 {
    text-align: center;
  }

  .AddressProofModal__description {
    font-size: 16px;
    color: #1d1d1d;
    margin-bottom: 30px;
    line-height: 1.6;
  }

  .AddressProofModal__buttons {
    display: flex;
    flex-direction: row;
    gap: 15px;
    justify-content: center;
  }

  .AddressProofModal__buttons button {
    min-width: 180px;
    padding: 12px 24px;
    font-size: 16px;
    border-radius: 8px;
  }

  .AddressProofModal__buttons button:first-child {
    background: #6c2bf5;
    color: white;
    border: none;
  }

  .AddressProofModal__buttons button:first-child:hover {
    background: #5a24cc;
  }

  .AddressProofModal__buttons button:last-child {
    background: white;
    color: #6c2bf5;
    border: 2px solid #6c2bf5;
  }

  .AddressProofModal__buttons button:last-child:hover {
    background: #f5f5f5;
  }
`;
